import { Box, TablePagination, Typography } from "@material-ui/core";
import React, { FC } from "react";
import LastPageIcon from "@material-ui/icons/LastPage";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import "./index.css";

interface Props {
  collectionLength: number;
  total: number;
  page: number;
  perPage: number;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleLastPage: () => void;
  handleFirstPage: () => void;
  title: string;
}

const PaginationTable: FC<Props> = ({
  collectionLength,
  total,
  page,
  perPage,
  handleChangePage,
  handleChangeRowsPerPage,
  handleLastPage,
  title,
  handleFirstPage,
}) => {
  return (
    <>
      {collectionLength === 0 && (
        <div className="no-active">
          <Typography variant="h6" gutterBottom className="base-color">
            No {title} to display
          </Typography>
        </div>
      )}
      {total > 0 && (
        <Box
          display="flex"
          alignItems="center"
          position="relative"
          paddingRight="1em"
          justifyContent="flex-end"
        >
          <TablePagination
            component="div"
            count={total}
            page={page - 1}
            onPageChange={handleChangePage}
            rowsPerPage={perPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            className="pagination-table"
          />
          <div
            className="last-page-icon"
            title="Last Page"
            onClick={handleLastPage}
          >
            <LastPageIcon className="last-icon" />
          </div>
          <Box position="absolute" right="160px">
            <div
              className="last-page-icon"
              title="First Page"
              onClick={handleFirstPage}
            >
              <FirstPageIcon />
            </div>
          </Box>
        </Box>
      )}
    </>
  );
};

export default PaginationTable;
